
import { Vue, Component } from 'vue-property-decorator'
import { CommonModule } from '@/store/module/common'
import { submitFilterTask } from '@/api/seTel'
import { getCountryList } from '@/api/tools'
import { Form } from 'element-ui'

@Component({
  name: 'AddFilter'
})
export default class addFilter extends Vue {
  get extInfo() {
    return CommonModule.currentInfo
  }

  get properCost() {
    const ammount = +CommonModule.currentInfo.Price/1000 * +this.submitData.Quantity
    return Number(String(ammount).replace(/^(.*\..{4}).*$/, '$1'))
  }

  submitData = {
    CountryCode: '',
    countryName: '',
    Quantity: '',
    Remarks: '',
    NumberTypeID: 0
  }
  init() {
    // 初始化数据
    this.submitData = {
      CountryCode: '',
      countryName: '',
      Quantity: '',
      Remarks: '',
      NumberTypeID: 0
    }
  }

  // // 点击选择地区触发事件
  // handleSelect() {
  //   const res = this.countryList.find(item => item.Code === this.submitData.CountryCode)
  //   if (res) {
  //     this.submitData.countryName = res.name
  //   }
  // }
  // 下拉框查询仓库接口
  countryList = []
  tempCountryData = []
  isLoading = false
  isFirst = true
  filterCountrys(){
      if (CommonModule.currentCountrys && CommonModule.currentCountrys.length > 0) {
          return this.countryList.filter(function (cc) {              
              if (CommonModule.currentCountrys.includes(cc.value)) {
                  return cc;
              }
          })
      } else {
          return this.countryList
      }
  }
  handleInitSelect() {
    // 用于首次点击下拉框时初始化数据
    if (this.isFirst) {
      this.isFirst = false
      this.getCountryList()
    }
  }
  remoteMethod(query: any) {
    if (query) {
      const temp = []
      this.tempCountryData.forEach(item => {
        if (item.label.includes(query)) {
          temp.push(item)
        }
      })
      this.countryList = temp
    } else {
      this.countryList = this.tempCountryData
    }
  }
  getCountryList() {
    this.isLoading = true
    getCountryList()
      .then((res: any) => {
        // 返回的格式必须是{label: '', value: ''}
        const list = res.list
        const temp: any[] = []
        list.forEach((item: any) => {
          temp.push({
            label: item.name,
            value: item.code
          })
        })
        this.tempCountryData = temp
        this.countryList = temp
      })
      .catch(err => {
        this.$message.error(err.msg)
      })
      .finally(() => {
        this.isLoading = false
      })
  }
  // 点选后重新校验表单
  handleSelect() {
    const createFormRef = this.$refs.createFormRef as Form
    createFormRef.validateField('CountryCode')
  }

  // 点击提交代筛任务
  handleConfirm() {
    if (+this.submitData.Quantity < this.extInfo.MinQuantity || +this.submitData.Quantity === 0) {
      this.$message.error('提交数量小于最低数量！')
    } else if (+this.submitData.Quantity > this.extInfo.MaxQuantity) {
      this.$message.error('提交数量大于最高数量！')
    } else {
      this.$confirm(`当前任务需消耗 ${this.properCost} ，确定后不可停止，是否继续？`, '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.submitData.NumberTypeID = +CommonModule.currentSubMenuID
          submitFilterTask(this.submitData)
            .then(() => {
              this.$message.success('添加成功')
              this.$emit('addSuccess')
            })
            .catch(err => {
              this.$message.error(err.msg)
            })
        })
        .catch(() => {
          console.log('cancel')
        })
    }
  }
}
